import { observable } from 'mobx'

export default class TrackerPrefStore {
  @observable tabSelected = 'add'
  @observable trackers = []
  @observable trackersActive = []
  @observable tracker = []
  @observable created = false
  @observable userId = ''
  @observable trackerToAc = []
  @observable datasetId = ''

  updateTrackers(data) {
    this.trackers = data
  }

  updateTrackersActiveFromAll() {
    const dataActive = this.trackers.filter(t => t.isActive === '1')
    this.trackersActive = dataActive
  }

  updateTracker(data) {
    this.tracker = data
  }

  updateCreated() {
    this.created = true
  }

  updateUserTrackerPreference(id, value) {
    // search the tracker to be activated, if none, then add here
    var trackersToAc = this.trackers.filter(t => t.id === id)
    if (trackersToAc.length === 0) {
      //('to add tracker to pref')
      this.trackers.splice(0, 0, {
        id: this.trackerToAc.id,
        name: this.trackerToAc.name,
        description: this.trackerToAc.description,
        img: '/cloud_done.png',
        isActive: '1'
      })
    } else if (trackersToAc.length === 1) {
      this.trackers.forEach((e, index) => {
        if (e.id === id) {
          this.trackers[index].isActive = value
        }
      })
    } else {
      console.log('Error: more than one of tracker #' + id)
    }
  }

  updateTrackerViaId(id) {
    this.trackersActive.forEach((e, index) => {
      if (e.id === id) {
        this.tracker = this.trackers[index]
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/TrackerPrefStore.js